import $ from 'jquery';
import { getState } from '~src/state';

export function updateTextBorderThicknessControl() {
  let strokeWidth;
  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      strokeWidth = activeObject.get('strokeWidth');
    } else if (selectionStart === selectionEnd) {
      strokeWidth = activeObject.get('strokeWidth');
    } else {
      const selectionStyles = activeObject.getSelectionStyles();
      if (selectionStyles && selectionStyles.length > 0 && selectionStyles[0]) {
        strokeWidth =
          selectionStyles[0]['strokeWidth'] || activeObject.get('strokeWidth');
      } else {
        strokeWidth = activeObject.get('strokeWidth');
      }
    }
  } else {
    strokeWidth = activeObject.get('strokeWidth');
  }

  $('#editor-text-border-thickness-slider').val(strokeWidth || 0);
  $('#editor-text-border-thickness-value').val(strokeWidth || 0);
}
